/**
 * DevCycle flag (same semantics as z1-ui-main's `maps-raw-data-cbx-only`).
 * One switch, two effects: when on, only CerebrumX units offer the OEM data
 * action and the modal hides its Raw JSON tab; when off, every unit offers it
 * and Raw JSON sits next to the manufacturer tabs.
 */
export const OEM_RAW_DATA_CBX_ONLY_FLAG = 'oem-raw-data-cbx-only';
/** Applies until the flag exists in DevCycle (or when the client is not initialized). */
export const OEM_RAW_DATA_CBX_ONLY_DEFAULT = true;
/**
 * Account permission module (px-databases P3-53958, code `oemdata`, userCode 379):
 * gates the OEM data action and the modal. Sub-users also need userCode 379 in their role.
 */
export const OEM_DATA_PERMISSION = 'oemdata';
export const OEM_DATA_USER_CODE = 379;
/** Material icon for the OEM data feature: the entry-point buttons and the modal header share it. */
export const OEM_DATA_ICON = 'car_repair';
/** How long the copy action reads "Copied". */
export const COPIED_FEEDBACK_MS = 2000;
/** Tab id of the JSON view (adapters must not reuse it). */
export const RAW_JSON_TAB = 'json';
/** Newest telemetry breadcrumbs listed on the Location tab; the rest stays in Raw JSON. */
export const CEREBRUMX_MAX_SAMPLE_ROWS = 20;
